export default "__VITE_ASSET__C0cHq69O__"